import React, { useRef } from 'react';
import ContactForm from '../ContactForm'; // Make sure this component has the `openForm` method.
import logoSrc from '../img/logo.png'; // Assuming logo.png is in the img folder
import './Thirdpartyservices.css'; // Assuming the CSS is in the same directory

function Consulting() {
  const contactFormRef = useRef(); // Reference for controlling the contact form

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };


  return (
    <>
    
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text">
            <h1 className="banner-title">insight that drives smart decisions</h1>
            <p className="banner-description">
              Leverage Shigjeta’s consulting expertise to guide your business toward success. We offer strategic insights, tailored solutions, and expert advice across various industries.
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>


          </div>
          {/* Background Image */}
          <div className="banner-background"></div>
        </div>
      </section>
      <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/Third Party Services Thumbnail.png"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
              alt="img"
            />
      </div>
      {/* Strategic Consulting Section */}
      <section className="about-section">
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Strategic Consulting</strong></h2>
            <p>
              We provide expert strategic consulting services that help you navigate complex business challenges and create sustainable growth.
            </p>
            <ul>
              <li><strong>Business Strategy:</strong> Develop actionable strategies for business growth.</li>
              <li><strong>Market Analysis:</strong> Insights to understand your market landscape.</li>
              <li><strong>Competitor Analysis:</strong> Identify strengths and weaknesses in your market.</li>
              <li><strong>Growth Strategies:</strong> Implement tailored strategies to accelerate growth.</li>
            </ul>
            <button className="cta-button">Learn More About Strategic Consulting</button>
          </div>
          <div className="about-image">
            <img src="/img/ts2.1.png" alt="Strategic Consulting" />
          </div>
        </div>

        {/* IT & Digital Transformation Section */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>IT & Digital Transformation</strong></h2>
            <p>
              Transform your business with the latest in IT and digital technologies. We guide you through digital transformations to enhance efficiency and unlock new opportunities.
            </p>
            <ul>
              <li><strong>System Integration:</strong> Seamless integration of new and legacy systems.</li>
              <li><strong>Cloud Services:</strong> Leverage cloud solutions to streamline operations.</li>
              <li><strong>Digital Strategy:</strong> Create a roadmap for digital growth.</li>
              <li><strong>Process Automation:</strong> Improve workflows and business processes.</li>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/ts2.2.png" alt="IT & Digital Transformation" />
          </div>
        </div>

        {/* Organizational Consulting Section */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Organizational Consulting</strong></h2>
            <p>
              Improve your organizational structure and efficiency with tailored consulting solutions. We help optimize your business for better productivity and team alignment.
            </p>
            <ul>
              <li><strong>Change Management:</strong> Guide your team through transitions.</li>
              <li><strong>Leadership Development:</strong> Build strong leadership capabilities.</li>
              <li><strong>Team Alignment:</strong> Ensure teams are working toward shared goals.</li>
              <li><strong>Operational Efficiency:</strong> Streamline processes for better results.</li>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/ts2.3.png" alt="Organizational Consulting" />
          </div>
        </div>

        {/* Consulting Success Stories Section */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Consulting Success Stories</strong></h2>
            <p>
              Explore how our consulting services have helped businesses grow, optimize operations, and achieve their strategic goals.
            </p>
            <a href='/blog' className="cta-button">Read Our Consulting Case Studies</a>
          </div>
          <div className="about-image">
            <img src="/img/ts2.4.png" alt="Consulting Success Stories" />
          </div>
        </div>
      </section>
      <ContactForm ref={contactFormRef} />
    </>
  );
}

export default Consulting;
